import clsx from 'clsx';
import React from 'react';

import Button from '@/src/components/common/Elements/Button/Button';
import Icon, { ICONS } from '@/src/components/common/Elements/Icon/Icon';
import { ReplyType, EmailEntry, EmailEntryListItem } from '@/src/components/project/Inbox2/types';
import { cn } from '@/src/util/ui';

import { useEmailThreadEntryViewer } from '../../../../../store/emailThreadEntryViewer.store';
type ToggleCreateReplyProps = {
  emailEntry: EmailEntry;
  emailEntryListItem: EmailEntryListItem;
};

const ToggleCreateReply = ({ emailEntry, emailEntryListItem }: ToggleCreateReplyProps) => {
  const { replyToEmail } = useEmailThreadEntryViewer();

  const handleClickReply = (replyType: ReplyType) => {
    replyToEmail({
      emailEntryToReply: emailEntry,
      selectedEmailEntryListItem: emailEntryListItem,
      replyType,
    });
  };

  const buttonStyles = cn(
    'tw-px-[10px] tw-py-[6px]',
    'hover:tw-border-cfo-blue-700 hover:tw-bg-cfo-blue-700 hover:tw-text-white'
  );

  const buttonClassSettings = { variant: 'inverse', size: 'sm', weight: 'bold' };

  return (
    <>
      <React.Fragment>
        <div
          className={clsx('container--emailReplyButton', 'tw-flex tw-items-center', 'tw-px-[10px]')}
        >
          {/* Reply */}
          <Button
            className={buttonStyles}
            buttonClassSettings={buttonClassSettings}
            onClick={() => handleClickReply(ReplyType.REPLY)}
          >
            Reply
            <Icon
              className={clsx('tw-ml-[5px]')}
              icon={ICONS.reply_icon({
                className: 'tw-fill-cfo-black group-hover:tw-fill-white',
              })}
            />
          </Button>

          {/* Reply All */}
          <Button
            className={buttonStyles}
            buttonClassSettings={buttonClassSettings}
            onClick={() => handleClickReply(ReplyType.REPLY_ALL)}
          >
            Reply All
            <Icon
              className={clsx('tw-ml-[5px]')}
              icon={ICONS.replyall_icon({
                className: 'tw-fill-cfo-black group-hover:tw-fill-white',
              })}
            />
          </Button>
        </div>
      </React.Fragment>
    </>
  );
};

export default ToggleCreateReply;
